import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../../graphql/types.generated';
export type GetEntitledAccountsFiltersQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
  searchQuery?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
}>;

export type GetEntitledAccountsFiltersQueryResult = { __typename?: 'Query' } & {
  entitledAccounts?: GraphQLTypes.Maybe<
    { __typename?: 'EntitledAccountsPayload' } & {
      account?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'tradingName'>>;
      businessUnits: Array<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'tradingName'>>;
      managed: Array<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'tradingName'>>;
      unmanaged: Array<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'tradingName'>>;
    }
  >;
};

export const GetEntitledAccountsFiltersDocument = gql`
  query getEntitledAccountsFilters($accountId: String!, $searchQuery: String) {
    entitledAccounts(accountId: $accountId, searchQuery: $searchQuery) {
      account {
        id
        tradingName
      }
      businessUnits {
        id
        tradingName
      }
      managed {
        id
        tradingName
      }
      unmanaged {
        id
        tradingName
      }
    }
  }
`;
